/* eslint-disable*/
// 構造式取得
function getMarvin() {
  return MarvinJSUtil.getEditor('#sketch-iframe').then(
    function (sketcherInstance) {
      if (sketcherInstance.isEmpty()) {
        return;
      }
      return sketcherInstance.exportStructure('mol', null);
    },
    function () {
      return 'error';
    }
  );
}

// 構造式クリア
function clearMarvin() {
  return MarvinJSUtil.getEditor('#sketch-iframe').then(
    function (sketcherInstance) {
      sketcherInstance.clear();
      return;
    },
    function () {
      return 'error';
    }
  );
}

export { getMarvin, clearMarvin };
